import React from "react";

function PrivacyPolicy() {
  return (
    <div className="container">
      <div className="mt-5 mx-3">
        <h1>Privacy Policy</h1>
        <p>
          <strong>Effective Date:</strong> [15/01/2026]
        </p>

        <p>
          Your privacy is important to us. This Privacy Policy explains how our
          PDF editing tools ("we", "our", or "Service") collect, use, and
          protect your information in compliance with the General Data
          Protection Regulation (GDPR) and the California Consumer Privacy Act
          (CCPA).
        </p>

        <h2>1. Information We Collect</h2>

        <h3>a) Uploaded Files</h3>
        <p>
          Although most of the operations are performed locally on your device,
          any PDF files uploaded for editing, compression, conversion, merging,
          splitting, watermarking etc are used only to perform the requested
          operation.
        </p>

        <h3>b) Automatically Collected Information</h3>
        <p>
          We may collect limited, non-personal information such as browser type,
          device type, operating system, IP address, and anonymous usage
          statistics for security and performance improvements.
        </p>

        <h3>c) Personal Information</h3>
        <p>
          Our service may require account creation to access certain features.
          When you create an account, we may collect limited personal
          information such as your name, email address, or login credentials.
          This information is used solely for account management,
          authentication, and service delivery.
        </p>

        <h2>2. Legal Basis for Processing (GDPR)</h2>
        <ul>
          <li>User consent when files are uploaded</li>
          <li>
            Legitimate interest to operate, secure, and improve our services
          </li>
          <li>Legal obligations where applicable</li>
        </ul>

        <h2>3. How We Use Your Information</h2>
        <ul>
          <li>To process PDF editing requests</li>
          <li>To improve tool performance and user experience</li>
          <li>To monitor security and prevent misuse</li>
        </ul>

        <p>
          We do not sell, rent, or share personal data with third parties for
          marketing purposes.
        </p>

        <h2>4. File Storage and Retention</h2>
        <p>
          Uploaded files are processed securely and automatically deleted after
          processing or within a short predefined time period. Offline tools
          process files locally on your device, and files never leave your
          system.
        </p>

        <h2>5. Your Rights Under GDPR</h2>
        <ul>
          <li>Access your data</li>
          <li>Request correction or deletion</li>
          <li>Restrict or object to processing</li>
          <li>Withdraw consent at any time</li>
          <li>Request data portability</li>
          <li>Lodge a complaint with a data protection authority</li>
        </ul>

        <h2>6. Your Rights Under CCPA</h2>
        <ul>
          <li>Know what personal data is collected</li>
          <li>Request deletion of personal data</li>
          <li>Opt out of the sale of personal data (we do not sell data)</li>
          <li>Non-discrimination for exercising your privacy rights</li>
        </ul>

        <h2>7. Cookies and Tracking Technologies</h2>
        <p>
          We may use cookies or similar technologies to remember user
          preferences and analyze website traffic. Cookies do not collect
          sensitive personal information. You may disable cookies in your
          browser settings.
        </p>

        <h2>8. Third-Party Services</h2>
        <p>
          We may use trusted third-party services such as analytics providers
          that process anonymous, aggregated data in compliance with GDPR and
          CCPA regulations.
        </p>

        <h2>9. Data Security</h2>
        <p>
          We use industry-standard security measures to protect your
          information. However, no method of online transmission or storage is
          completely secure.
        </p>

        <h2>10. International Data Transfers</h2>
        <p>
          If data is processed outside your country, appropriate safeguards are
          implemented to ensure compliance with applicable data protection laws.
        </p>

        <h2>11. Children’s Privacy</h2>
        <p>
          Our services are not intended for children under the age of 13. We do
          not knowingly collect personal data from children.
        </p>

        <h2>12. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Changes will be
          posted on this page and take effect immediately upon publication.
        </p>

        <h2>13. Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy or wish to exercise
          your privacy rights, please contact us through our website.
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
